var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('v-icon',{staticStyle:{"margin-top":"-3px","font-size":"1.1rem"}},[_vm._v("mdi-information-variant")]),_vm._v(" Need Help? "),_c('span',{staticClass:"link text-primary",on:{"click":_vm.openWhatsApp}},[_vm._v("Contact Us")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }